module.exports = __webpack_public_path__ + "img/solutions-bg.bdda3609.svg";